import { render, staticRenderFns } from "./single_chart.vue?vue&type=template&id=10da1ad4&scoped=true&"
import script from "./single_chart.vue?vue&type=script&lang=js&"
export * from "./single_chart.vue?vue&type=script&lang=js&"
import style0 from "./single_chart.vue?vue&type=style&index=0&id=10da1ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da1ad4",
  null
  
)

export default component.exports